import { ChakraProvider, defaultSystem } from '@chakra-ui/react'
import { ColorModeProvider } from './color-mode'

export function Provider(props: { children: React.ReactNode }) {
    return (
        <ChakraProvider value={defaultSystem}>
            <ColorModeProvider>{props.children}</ColorModeProvider>
        </ChakraProvider>
    )
}
